import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, Transition as _Transition, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "mt-4 centered"
};
const _hoisted_2 = {
    key: 0,
    class: "mt-4 tagsList"
};
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import TransactionsList from './elements/TransactionsList.vue';
import InfoPanel from './elements/InfoPanel.vue';
import SwipeActionsContainer from './elements/SwipeActionsContainer.vue';
import MGExpansionPanel from './elements/MGExpansionPanel.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'SpendByCustomerTagPage',
    setup(__props) {
        const state = useAppState();
        const router = useRouter();
        useAuth();
        const { getCustomer, getCustomerTags, getTransactionsForCustomerTag, deleteCustomerTag, clearCustomerTagsCache } = useCustomer();
        const customerTags = ref(null);
        function goToTransaction(t) {
            if (!t?.id)
                return;
            router.push('/TransactionDetail/' + t.id);
        }
        function handleAction({ item, action } = { item: null, action: null }) {
            if (!item || !action)
                return;
            if (action.type === 'delete') {
                customerTags.value = (customerTags.value ?? []).filter((t) => t.id !== item.id);
                deleteCustomerTag(item.id, () => {
                    clearCustomerTagsCache();
                });
            }
        }
        function onLoad() {
            getCustomer(() => {
                getCustomerTags((result) => {
                    customerTags.value = result;
                    customerTags.value.forEach((tag) => {
                        tag.total = 0;
                        getTransactionsForCustomerTag(tag.id, (gt) => {
                            tag.groupedTransactions = gt;
                            tag.groupedTransactions.forEach((g) => {
                                g.forEach((t) => {
                                    tag.total += t.amount;
                                });
                            });
                        });
                    });
                });
            });
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, { title: "#Tagged Transactions" }),
                _createVNode(CustomerLoadWait, { customer: customerTags.value }, null, 8, ["customer"]),
                _createVNode(InfoPanel, {
                    icon: require('@/assets/Frame.png'),
                    title: "#Spending, Your Way",
                    subtitle: "Ever wish you could easily see how much you're spending on specific things, like that awesome weekend getaway or your home renovation project? Custom #tags allow you to do just that."
                }, null, 8, ["icon"]),
                (customerTags.value && customerTags.value.length == 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_1, "You have not added any #tags yet, head over to a transaction's details and add your own now!"))
                    : _createCommentVNode("", true),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (customerTags.value && customerTags.value.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _createVNode(SwipeActionsContainer, {
                                    items: customerTags.value,
                                    preview: true,
                                    backgroundColor: 'var(--background-color-alt)',
                                    actions: [
                                        {
                                            image: require('@/assets/trashcan.png'),
                                            type: 'delete',
                                            backgroundColor: 'var(--background-color-alt6)'
                                        }
                                    ],
                                    onActionClick: handleAction
                                }, {
                                    default: _withCtx(({ item: t }) => [
                                        _createVNode(MGExpansionPanel, null, {
                                            title: _withCtx(() => [
                                                _createVNode(_component_v_row, { class: "titleRow" }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_col, null, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(" #" + _toDisplayString(t.tag), 1)
                                                            ]),
                                                            _: 2
                                                        }, 1024),
                                                        _createVNode(_component_v_col, { class: "right" }, {
                                                            default: _withCtx(() => [
                                                                _createTextVNode(_toDisplayString(_unref(state).formatter.format(t.total)), 1)
                                                            ]),
                                                            _: 2
                                                        }, 1024)
                                                    ]),
                                                    _: 2
                                                }, 1024)
                                            ]),
                                            default: _withCtx(() => [
                                                _createVNode(TransactionsList, {
                                                    showDateTotal: true,
                                                    transactions: t.groupedTransactions,
                                                    formatter: _unref(state).formatter,
                                                    onTransactionClick: goToTransaction,
                                                    emptyDescription: "Go forth and #tag!"
                                                }, null, 8, ["transactions", "formatter"])
                                            ]),
                                            _: 2
                                        }, 1024)
                                    ]),
                                    _: 1
                                }, 8, ["items", "actions"])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                })
            ], 64));
        };
    }
});
